module.exports = __webpack_public_path__ + "img/antes_despues_67.9b8a8980.png";